<template>
  <!-- Absolutely positioned so revealing it never reflows the selector grid, and
       pointer-events-none so it cannot swallow interaction the card still wants
       (the region globe stays draggable while locked). Needs `group` on the
       wrapping element to drive the hover.

       bottom-24 (96px) clears the tallest of the three footer buttons — the
       region one stacks a label above its value and reaches ~76px. -->
  <div
    class="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-transparent transition-colors duration-150 group-hover:ring-gray-600"
  >
    <div
      class="absolute left-2 right-2 bottom-24 flex justify-center opacity-0 transition-opacity duration-150 group-hover:opacity-100"
    >
      <span
        class="inline-flex items-center gap-1.5 rounded-md bg-gray-800/95 px-2.5 py-1.5 text-xs text-gray-200 shadow-lg"
      >
        <LockClosedIcon class="w-3 h-3 text-gray-400 flex-shrink-0" aria-hidden="true" />
        {{ reason }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { LockClosedIcon } from '@heroicons/vue/24/solid';

defineProps({
  reason: { type: String, required: true },
});
</script>
